import useSWR from 'swr';
import { API_GET_TEAMS } from '../api/configurationScreenServices';

const fetcher = async () => {
  const res = await API_GET_TEAMS(true);
  if (res?.status !== 200) throw new Error('teams fetch failed');
  return res.data;
};

export const teamsKey = 'teams';

export function useTeams() {
  return useSWR(teamsKey, fetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false
  });
}

// Convenience accessor for the common case. Teams load in the background
// (they no longer gate app render), so data may still be undefined on first
// paint. Falls back to [] — the API returns an array, and [] is safe to pass
// to hierarchyToLinear and to iterate.
export function useTeamsHierarchy() {
  return useTeams().data || [];
}
